import { memo, useState } from "react";
import { genderListSelect, typeAdminListSelect } from "../../../constant";
import InputSelect from "../../InputSelect";
import InputText from "../../InputText";

// interface StaffType {
//     id: number;
//     fullName: string;
//     gender: Gender;
//     dateOfBirth: string;
//     email: string;
//     phoneNumber: string;
//     address: string;
//     roles: string[];
//     status: UserStatus;
//     staff: {
//         id: number;
//     }
//     branch: {
//         code: BranchCode;
//         name: string;
//     }
// }

function Staff() {

    // const [editingId, setEditingId] = useState<number | null>(null);
    const [form, setForm] = useState<any>({});
    // const [isModalOpen, setIsModalOpen] = useState(false);

    const handleInputChange = (field: string, value: any) => {
        setForm((prev: any) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleCreateAdmin = () => {
        console.log("form", form);
    }

    return (<div className="text-white p-[20px] pt-[10px] w-full h-screen">
        <h1 className="font-bold text-[30px] text-center">THÊM ADMIN</h1>
        <div className="space-y-4 w-[30%]">
            <InputText
                label="Email"
                value={form.email}
                onChange={(e) => handleInputChange('email', e.target.value)}
                name="email"
                inputStyle="text-black"
            />
            <InputText
                label="Mật khẩu"
                value={form.password}
                onChange={(e) => handleInputChange('password', e.target.value)}
                name="password"
                type="password"
                inputStyle="text-black"
            />
            <InputText
                label="Họ và tên"
                value={form.fullName}
                onChange={(e) => handleInputChange('fullName', e.target.value)}
                name="fullName"
                inputStyle="text-black"
            />
            <InputSelect
                label="Giới tính"
                value={form.gender}
                onChange={(e) => handleInputChange('gender', e.target.value)}
                data={genderListSelect}
                name="gender"
                inputStyle="text-black"
            />
            <div>
                <label className="block text-sm font-medium mb-2">Ngày sinh</label>
                <input
                    type="date"
                    value={form.dateOfBirth}
                    onChange={(e) => handleInputChange('dateOfBirth', e.target.value)}
                    className="w-full px-3 py-2 rounded bg-white text-black"
                />
            </div>
            <InputText
                label="Số điện thoại"
                value={form.phoneNumber}
                onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                name="phoneNumber"
                inputStyle="text-black"
            />
            <InputText
                label="Địa chỉ"
                value={form.address}
                onChange={(e) => handleInputChange('address', e.target.value)}
                name="address"
                inputStyle="text-black"
            />
            <InputSelect
                label="Type"
                value={form.type}
                onChange={(e) => handleInputChange('type', e.target.value)}
                data={typeAdminListSelect}
                name="type"
                inputStyle="text-black"
            />
            <button
                onClick={handleCreateAdmin}
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed"
            >
                Thêm
            </button>
        </div>
    </div >);
}

export default memo(Staff);